import type { PortTypeResponse } from './api';

export const normalizePortTypes = (list: PortTypeResponse): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.text,
    value: row.value,
  }));
};
